// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2Cg_a","inputWrap":"CustomTip_inputWrap__2lAcw"};